const t = "_notificationContainer_1i8vp_24", o = "_inverted_1i8vp_32", n = "_isInStackFromTop_1i8vp_50", i = "_isInStackFromBottom_1i8vp_53", a = {
  notificationContainer: t,
  inverted: o,
  isInStackFromTop: n,
  isInStackFromBottom: i
};
export {
  a as default,
  o as inverted,
  i as isInStackFromBottom,
  n as isInStackFromTop,
  t as notificationContainer
};
//# sourceMappingURL=index.es760.js.map
